import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiInvoice, InvoicesService } from 'src/app/services/invoices.service';

type Sort = {
  field: string;
  direction: 'ASC' | 'DESC';
};

@Component({
  selector: 'app-api-invoices-table',
  templateUrl: './api-invoices-table.component.html',
  styleUrl: './api-invoices-table.component.scss',
})
export class ApiInvoicesTableComponent {
  @Input('invoices') invoices!: ApiInvoice[];
  @Input('current-sort') currentSort?: Sort;
  @Output('sort-changed') sortChanged = new EventEmitter<string>();
  @Output('delete-invoice') deleteEmitter = new EventEmitter<ApiInvoice>();
  @Output('change-status') changeStatusEmitter = new EventEmitter<ApiInvoice>();

  constructor(private invoicesService: InvoicesService) {}

  ngOnInit(): void {
    console.log('api invoices: ', this.invoices);
  }

  browseToInvoice(invoiceId: string, tenantId: string) {
    window.location.href =
      '/admin/tenant/' + tenantId + '/api-invoice/' + invoiceId;
  }

  get showDeleteButton() {
    return this.invoices.every((i) => !i.completed);
  }

  get showStatusButton() {
    return this.invoices.every((i) => i.completed);
  }

  getDisplayTransactionMonth(yyyymm: string): Date {
    return this.invoicesService.getDisplayTransactionMonth(yyyymm);
  }

  deleteInvoice(ev: Event, invoice: ApiInvoice) {
    // stop event from bubbling up to parent and browsing to invoice page
    ev.stopPropagation();
    console.log('ev: ', ev);
    console.log('invoice: ', invoice);
    this.deleteEmitter.emit(invoice);
  }

  changeStatus(ev: Event, invoice: ApiInvoice) {
    ev.stopPropagation();
    this.changeStatusEmitter.emit(invoice);
  }
}
